var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9842 5H5.01582C5.00708 5 5 5.00708 5 5.01582V58.9842C5 58.9929 5.00708 59 5.01582 59H58.9842C58.9929 59 59 58.9929 59 58.9842V5.01582C59 5.00708 58.9929 5 58.9842 5Z",
    fill: "#CC6699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 11C20.25 15.125 12.5 23.5 13.25 28.5C14 33.5 21.5 37.5 24.875 40.125C20.5 42.375 15 45.75 15.125 50.125C15.375 56.125 21.875 54.25 24.625 52.5C27.375 50.75 30.125 45.875 28.375 40.75C32.25 39.75 35.625 41 36.625 41.75C40.5 44.5 38.5 47.625 37.125 48.125C35.75 48.625 36.625 48.875 37.5 48.625C38.375 48.375 40.25 47.125 40.25 45C40.25 39.625 34.5 37.125 27.375 39C23.25 34.625 17.625 32.625 17.875 27.875C18 26.125 18.625 21.625 29.75 16C40.875 10.375 48.75 12.625 47.75 17.75C46.25 25.5 32.75 30.75 28 26.25C27.75 25.75 26.875 25.375 27.375 26.75C29.875 33 50.125 30.125 51 16.875C51.25 9.87498 41.125 7.99998 32.25 11ZM21.5 51C18.375 52 18.5 50 18.625 49.25C19 47.125 20.75 44.5 26 41.875C27.5 46.625 24.125 50.25 21.5 51Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSassIcon);
export default __webpack_public_path__ + "static/media/sass_icon.ce6ad9c7276d1418368012c7de8abc4f.svg";
export { ForwardRef as ReactComponent };